const dialogSkin = {
  "@keyframes fadeIn": {
    "0%": { opacity: "0.1" },
    "66%": { opacity: " 0.5" },
    "100%": { opacity: "1" },
  },
  dialog: {
    position: "fixed",
    zIndex: "9999",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: "var(--gc-default-background)",
    color: "var(--gc-default-text-color)",
  },
  "modal-dialog": {
    position: "relative",
    margin: "1.75rem auto",
    width: "100%",
    maxWidth: "500px",
    borderRadius: "0.3rem",
    backgroundColor: "var(--gc-dark-background)",
    boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
    "@media (min-width: 576px)": {
      maxWidth: "500px",
      margin: "1.75rem auto",
    },
    "@media (min-width: 992px)": {
      maxWidth: "800px",
    },
    "@media (min-width: 1200px)": {
      maxWidth: "1140px",
    },
  },
  "modal-content": {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    pointerEvents: "auto",
    backgroundColor: "var(--gc-dark-background)",
    backgroundClip: "padding-box",
    border: "1px solid rgba(0, 0, 0, 0.2)",
    borderRadius: "0.3rem",
    outline: "0",
  },
  "dialog-open": {
    display: "block",
    opacity: "0",
    animation: "$fadeIn 0.15s ease 0s normal forwards 1",
  },
  "dialog-closed": {
    display: "none",
    opacity: "0",
    animation: "none",
  },
  "dialog-header": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem 1rem",
    borderBottom: "1px solid var(--gc-border-separator-color)",
    borderTopLeftRadius: "calc(0.3rem - 1px)",
    borderTopRightRadius: "calc(0.3rem - 1px)",
    backgroundColor: "var(--gc-dark-background)",
    color: "var(--gc-dark-background-text-color)",
  },
  "dialog-title": {
    composes: "modal-title",
  },
  "dialog-close-button": {
    composes: "btn-close",
    "button&": {
      cursor: "pointer",
    },
  },
};

export default dialogSkin;
